"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBeginHour = getBeginHour;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _zipcode = require("../zipcode");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Checks if two moment.js objects represent the same day.
 *
 * @param {moment.Moment} selectedDay - The selected day.
 * @param {moment.Moment} day - The day to compare with the selected day.
 * @returns {boolean} Returns true if the two moments represent the same day, otherwise returns false.
 */
var isEqualDays = function isEqualDays(selectedDay, day) {
  return selectedDay && selectedDay.isSame(day, 'day');
};
var firstHour = 7;
var lastHour = 21;
var intervalForFirstSlotInHours = 6;
var firstSlotOfToday = 13;

/**
 * Retrieves the interval for the first slot in hours based on the provided zipcode.
 *
 * @param {string} zipcode - The zipcode to retrieve the interval for.
 * @returns {number} The interval for the first slot in hours.
 */
var getInterval = function getInterval(zipcode) {
  var zipcodeDataFound = (0, _zipcode.getZipcode)(zipcode);
  return (zipcodeDataFound === null || zipcodeDataFound === void 0 ? void 0 : zipcodeDataFound.intervalForFirstSlotInHours) || intervalForFirstSlotInHours;
};

/**
 * Returns the beginning hour for slot availability based on the given parameters.
 *
 * @param {string} zipcode - The zipcode for which the slot availability is being calculated.
 * @param {string} selectedDay - The selected day for which the slot availability is being calculated.
 * @param {moment.Moment} now - The current moment object. Defaults to the current time.
 * @returns {number} - The beginning hour for slot availability.
 */
function getBeginHour(zipcode, selectedDay) {
  var now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _momentTimezone["default"])();
  var tomorrow = (0, _momentTimezone["default"])(now).add(1, 'day');
  var interval = getInterval(zipcode) || intervalForFirstSlotInHours;
  var firstAvailableSlotInHours = now.hours() + interval;
  if (isEqualDays(selectedDay, now)) return Math.max(firstSlotOfToday, firstAvailableSlotInHours);
  if (isEqualDays(selectedDay, tomorrow) && firstAvailableSlotInHours > lastHour) return firstSlotOfToday;
  return firstHour;
}